<script lang="ts">
  import Separator from "$components/+shared/Separator/Separator.svelte";
  import { auth } from "app/stores/auth";
  import { AuthType, getLoginContext } from "pages/CommunityServerPage/CommunityLoginModal.svelte";
  import Button from "$components/+design-system/Button/Button.svelte";
  import { community, isPrivateCommunity, permissionsFetched } from "$stores/community";
  import { isCommunityMember } from "$stores/permissions";
  import cx from "classnames";

  export let customPositioning: string = "";
  export let hideLogin: boolean = false;

  const { login, join } = getLoginContext();
</script>

<!-- Custom positioning is used to override this default positioning of the sections. -->
<div class="top-bar sticky top-0 z-topbar @container/top-bar-layout">
  <div
    class={cx(
      customPositioning || "flex items-center justify-between gap-x-2 px-4 md:px-2.5",
      "h-[48px]"
    )}
  >
    <div
      class="flex grow items-center overflow-hidden text-sm font-medium text-gray-500 md:text-[13px] dark:text-white"
    >
      <slot name="left-section" />
    </div>
    <slot name="middle-section" class="truncate lg:w-full" />
    <div class="flex items-center justify-end gap-2 whitespace-nowrap sm:relative">
      <!-- Login/Signup buttons -->
      {#if !hideLogin}
        {#if $auth.isAnonymous}
          <Button variant="tertiary" label="Log in" on:click={() => login(AuthType.SignIn)} />
        {/if}
        {#if $permissionsFetched && !$isCommunityMember && !$isPrivateCommunity}
          <div class="hidden lg:block">
            <Button variant="community" label="Join {$community.name}" on:click={() => join()} />
          </div>
        {/if}
      {/if}
      <slot name="right-section" />
    </div>
  </div>
  <Separator class="mt-auto" />
</div>
